import React from 'react';
import Header from './common/Header';
import { theme } from '../styles/theme';

const QATraining = ({ user, setUser }) => {
  return (
    <div className="min-h-screen bg-white">
      <Header 
        user={user} 
        setUser={setUser}
        title="QA Training"
      />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold mb-2" style={{ color: theme.colors.text.primary }}>
            QA Training
          </h1>
          <p className="text-lg mb-6" style={{ color: theme.colors.text.secondary }}>
            Quality assurance training management and tracking
          </p>

          {/* QA Training specific content will go here */}
          <div className="bg-white rounded-xl shadow-lg p-6 border" style={{ borderColor: theme.colors.border.light }}>
            <p className="text-center text-gray-500">
              QA Training content is being configured...
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default QATraining;
